<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <div class="tw-px-[26px]">
      <div class="tw-mb-[15px] tw-flex tw-justify-between tw-gap-[10px]">
        <div class="tw-flex tw-gap-[10px]">
          <button
            class="tw-app-btn-primary"
            @click="$modal.show('addModelModal', { callback: clickLoadData })"
          >
            <img
              :src="require(`@/assets/icons/addwhite.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            {{ dataLang.vehicle_examples__btn__btn_add_model }}
          </button>
          <button
            class="tw-app-btn-primary-outline"
            @click="deleteActionAndModal"
          >
            <img
              :src="require(`@/assets/icons/minus-dark.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            {{ dataLang.vehicle_examples__btn__btn_delete_model }}
          </button>
        </div>

        <button class="tw-app-btn-primary" @click="openMarksModal">
          {{ dataLang.vehicle_marks_btn_btn_add_mark }}
        </button>
      </div>
    </div>

    <vue-tabs @tab-change="handleTabChange" class="vue-tabs-type-1">
      <v-tab
        title="Легковой транспорт"
        ref="car"
        data-type="car"
        data-type-id="1"
      >
        <div class="tw-relative tw-px-[26px] tw-mt-[15px]">
          <BaseLoader
            v-if="loadStatus == 'request'"
            class="tw-min-h-[400px]"
          ></BaseLoader>
          <ve-table
            class="rest-style-table"
            :columns="columnsMainTable"
            :table-data="vehicleTypeAndCharacteristicsFiltered || []"
            :border-x="true"
            :border-y="true"
            row-key-field-name="car_examples__id"
            :checkbox-option="{
              hideSelectAll: false,
              selectedRowChange: selectedRowChangeMainTable,
              selectedAllChange: selectedAllChangeMainTable,
            }"
            :clickHighlight="false"
            :eventCustomOption="eventCustomOption"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
            :sort-option="sortOptionMainTable"
          />
        </div>
      </v-tab>
    </vue-tabs>

    <BaseModal
      name="deleteModal"
      width="420"
      height="320"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deleteModal')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Точно удалить?</div>

          <div class="tw-h-[5px]"></div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="$modal.hide('deleteModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              Отменить
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="marksModal"
      width="650"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('marksModal')"
        ></button>
        <div>
          <div class="tw-app-modal__title">Марки</div>

          <div class="tw-mb-[15px] tw-flex tw-gap-[10px]">
            <button
              class="tw-app-btn-primary"
              @click="
                $modal.show('addMarkModal', {
                  callback: () => {
                    getAllMarks({ limit: 10000 });
                  },
                })
              "
            >
              <img
                :src="require(`@/assets/icons/addwhite.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              Добавить
            </button>
            <button
              class="tw-app-btn-primary-outline"
              @click="deleteAllSelected"
            >
              <img
                :src="require(`@/assets/icons/minus-dark.svg`)"
                width="13.5"
                height="13.5"
                class="tw-my-[-5px]"
              />
              Удалить
            </button>
          </div>

          <div>
            <ve-table
              class="rest-style-table"
              style="width: 100%"
              :columns="columns"
              :table-data="vehicleMarks"
              v-if="loadStatus == 'success'"
              :border-x="true"
              :border-y="true"
              row-key-field-name="vehicle_marks__id"
              ref="mainTable"
              :max-height="500"
              :sort-option="sortOption"
              :clickHighlight="false"
              :eventCustomOption="eventCustomOption"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false,
              }"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </div>
      </div>
    </BaseModal>
    <AddMarkModal />
    <AddModelModal
      @added="getAll({ vehicleType: activeTab, page: 1, limit: 10000 })"
    />
  </div>
</template>

<script>
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import Modal from "@/components/Modals.vue";
import EventBus from "@/event-bus.js";
import { TimeScale } from "chart.js";
import SelectsService from "@/api/SelectsService";
import Vue from "vue";
import VehicleMarksService from "@/api/VehicleMarksService";
import AddMarkModal from "@/views/marks-modals/AddMarkModal.vue";
import AddModelModal from "@/views/marks-modals/AddModelModal.vue";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
export default {
  // TODO нужно сделать вывод крутилки по типу модуля, от которого идет именение стейта. Взять имя модуля или что-то такое
  components: {
    VueTabs,
    VeTable,
    VTab,
    Modal,
    AddMarkModal,
    AddModelModal,
  },

  props: {},
  data() {
    return {
      filters: {},
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("addMarkModal", {
                callback: this.clickLoadData,
                data: row,
                id: row.vehicle_examples__id,
              });
            },
          };
        },
      },
      fileRecords: null,
      dataMarksModal: {},
      myData: null,
      dataForModal: {},
      activeTab: "car",
      vehicleTypeId: 1,
      editData: {},
      updatedValues: {},
      activeSelectRow: null,
      newMarkName: null,
      bodyTypesCarsSelectOptions: [],
      bodyTypesCarsSelectedOption: null,
      vehicleClassCarsSelectOptions: [],
      vehicleClassCarsSelectedOption: null,
      vehicleMarksSelectOptions: [],
      vehicleMarksSelectedOption: null,
      activeSelectRowsMultiple: [],
      activeSelectRowsMultipleMainTable: [],
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      sortOptionMainTable: {
        sortChange: (params) => {
          this.sortChangeMainTable(params);
        },
      },
      vehicleTypeAndCharacteristicsFiltered: [],
    };
  },
  methods: {
    fillFilter(data) {
      if (
        data.value === "" ||
        data.value === null ||
        data.value === undefined
      ) {
        this.$delete(this.filters, data.name);
      } else {
        this.$set(this.filters, data.name, data.value);
      }

      this.vehicleTypeAndCharacteristicsFiltered =
        this.vehicleTypeAndCharacteristics.filter((item) => {
          return Object.keys(this.filters).every((key) => {
            const filterValue = this.filters[key];
            if (
              filterValue === "" ||
              filterValue === null ||
              filterValue === undefined
            ) {
              return true;
            }
            if (!(key in item)) return false;
            const itemValueStr = String(item[key]).toLowerCase();
            const filterValueStr = String(filterValue).toLowerCase();
            return itemValueStr === filterValueStr;
          });
        });
    },
    sortChange(params) {
      this.vehicleMarks.sort((a, b) => {
        if (params.vehicle_marks__id) {
          if (params.vehicle_marks__id === "asc") {
            return a.vehicle_marks__id - b.vehicle_marks__id;
          } else if (params.vehicle_marks__id === "desc") {
            return b.vehicle_marks__id - a.vehicle_marks__id;
          } else {
            return 0;
          }
        } else if (params.vehicle_marks__name) {
          if (params.vehicle_marks__name === "asc") {
            if (a.vehicle_marks__name < b.vehicle_marks__name) return -1;
            if (a.vehicle_marks__name > b.vehicle_marks__name) return 1;
            return 0;
          } else if (params.vehicle_marks__name === "desc") {
            if (a.vehicle_marks__name > b.vehicle_marks__name) return -1;
            if (a.vehicle_marks__name < b.vehicle_marks__name) return 1;
            return 0;
          } else {
            return 0;
          }
        }
      });
    },
    sortChangeMainTable(params) {
      this.vehicleTypeAndCharacteristicsFiltered.sort((a, b) => {
        if (params.vehicle_examples__company_id) {
          if (params.vehicle_examples__company_id === "asc") {
            return (
              a.vehicle_examples__company_id - b.vehicle_examples__company_id
            );
          } else if (params.vehicle_examples__company_id === "desc") {
            return (
              b.vehicle_examples__company_id - a.vehicle_examples__company_id
            );
          } else {
            return 0;
          }
        }
        if (params.car_examples__id) {
          if (params.car_examples__id === "asc") {
            return a.car_examples__id - b.car_examples__id;
          } else if (params.car_examples__id === "desc") {
            return b.car_examples__id - a.car_examples__id;
          } else {
            return 0;
          }
        }
        if (params.vehicle_marks__name) {
          const valA = a.vehicle_marks__name;
          const valB = b.vehicle_marks__name;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.vehicle_marks__name === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.vehicle_examples__model) {
          const valA = a.vehicle_examples__model;
          const valB = b.vehicle_examples__model;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.vehicle_examples__model === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.car_examples__body_generation) {
          const valA = a.car_examples__body_generation;
          const valB = b.car_examples__body_generation;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.car_examples__body_generation === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.car_examples__body_type) {
          const valA = a.car_examples__body_type;
          const valB = b.car_examples__body_type;
          if (valA === null && valB === null) return 0;
          if (valA === null) return 1;
          if (valB === null) return -1;
          const order = params.car_examples__body_type === "asc" ? 1 : -1;
          return (
            valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            }) * order
          );
        }
        if (params.car_examples__count_doors) {
          if (params.car_examples__count_doors === "asc") {
            return a.car_examples__count_doors - b.car_examples__count_doors;
          } else if (params.car_examples__count_doors === "desc") {
            return b.car_examples__count_doors - a.car_examples__count_doors;
          } else {
            return 0;
          }
        }
        if (params.car_examples__count_places) {
          if (params.car_examples__count_places === "asc") {
            return a.car_examples__count_places - b.car_examples__count_places;
          } else if (params.car_examples__count_places === "desc") {
            return b.car_examples__count_places - a.car_examples__count_places;
          } else {
            return 0;
          }
        }
        if (params.car_examples__trunk_volume) {
          if (params.car_examples__trunk_volume === "asc") {
            return a.car_examples__trunk_volume - b.car_examples__trunk_volume;
          } else if (params.car_examples__trunk_volume === "desc") {
            return b.car_examples__trunk_volume - a.car_examples__trunk_volume;
          } else {
            return 0;
          }
        }
        if (params.car_examples__ground_clearance) {
          if (params.car_examples__ground_clearance === "asc") {
            return (
              a.car_examples__ground_clearance -
              b.car_examples__ground_clearance
            );
          } else if (params.car_examples__ground_clearance === "desc") {
            return (
              b.car_examples__ground_clearance -
              a.car_examples__ground_clearance
            );
          } else {
            return 0;
          }
        }
        if (params.car_examples__tank_capacity) {
          if (params.car_examples__tank_capacity === "asc") {
            return (
              a.car_examples__tank_capacity - b.car_examples__tank_capacity
            );
          } else if (params.car_examples__tank_capacity === "desc") {
            return (
              b.car_examples__tank_capacity - a.car_examples__tank_capacity
            );
          } else {
            return 0;
          }
        }
      });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedRowChangeMainTable({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultipleMainTable = selectedRowKeys;
    },
    selectedAllChangeMainTable({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultipleMainTable = selectedRowKeys;
    },
    deleteAllSelected() {
      if (this.activeSelectRowsMultiple.length) {
        this.localLoading = true;
        GeneralService.delete(`/marks/${this.activeSelectRowsMultiple}`)
          .then((data) => {
            this.getAllMarks({ limit: 10000 });
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
    newMarkNameDefault(data) {
      this.newMarkName = data.value;
    },
    submitMarks() {
      //
      if (this.newMarkName.trim() || this.fileRecords) {
        this.createOneMark({
          file: this.fileRecords.file,
          type: "default",
          newName: this.newMarkName,
        });
        this.newMarkNameDefault({ value: "" });
        this.fileRecords = null;
        EventBus.$emit("closeModal", {
          data: null,
          nameForAction: "marksModal",
          mode: "create",
        });
      } else {
        Vue.$toast.error("Заполните все поля для марки", { duration: 5000 });
      }
    },
    onBeforeDelete(e) {
      this.fileRecords = null;
    },
    fileDeleted(e) {
      this.fileRecords = null;
    },
    openMarksModal() {
      this.$modal.show("marksModal", {
        callback: () => {
          this.getAllMarks({ limit: 10000 });
        },
      });
      // EventBus.$emit('openModal', {
      //   data: null,
      //   nameForAction: 'marksModal',
      //   mode: 'create'
      // })
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultipleMainTable.length) {
        this.$modal.show("deleteModal");
      } else {
        this.$toast.error("Вы не выбрали ни одного поля", { duration: 5000 });
      }
    },
    deleteRow() {
      this.deleteOne(this.activeSelectRowsMultipleMainTable);
      this.$modal.hide("deleteModal");
      this.activeSelectRowsMultipleMainTable = [];
    },
    canselModal() {
      this.closeModal();
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },
    updateMark(data) {
      this.updatedValues["vehicle_examples__mark_id"] = data.vehicle_marks__id;
    },
    updateSelectValue(data) {
      this.updatedValues[data.field] = data.value;
    },
    openModalForCreate() {
      this.updatedValues = {};
      this.$modal.show("marksModal");
    },
    closeModal(nameModal = this.activeTab) {
      EventBus.$emit("closeModal", { nameForAction: nameModal });
      this.$refs[`${this.activeTab}Modal`]
        .querySelectorAll("input")
        .forEach((element) => {
          element.value = "";
        });
    },
    sendDataFromModal() {
      if (this.dataForModal.car_examples__id) {
        this.editOne({
          id: this.dataForModal.vehicle_examples__id,
          data: this.updatedValues,
        });
        EventBus.$emit("closeModal", { nameForAction: this.activeTab });
      } else {
        this.createOne(
          Object.assign(this.updatedValues, {
            vehicle_examples__vehicle_type: this.activeTab,
          })
        );
        EventBus.$emit("closeModal", { nameForAction: this.activeTab });
        this.closeModal();
        this.$refs.car.$el.querySelectorAll("input").forEach((elem) => {
          elem.value = "";
        });
      }
    },
    clickLoadData(numPage = 1) {
      this.getAll({
        vehicleType: this.activeTab,
        limit: 10000,
        page: numPage,
      });
    },
    ...mapActions("vehicleTypeAndCharacteristicsModule", [
      "getAll",
      "editOne",
      "createOne",
      "deleteOne",
    ]),
    ...mapActions("vehicleMarksModule", ["getAllMarks", "createOneMark"]),
    ...mapActions("storageFileModule", ["uploadFiles"]),
    handleTabChange(tabIndex, newTab, oldTab) {
      if (!(newTab.$attrs["data-type"] == this.activeTab)) {
        this.activeTab = newTab.$attrs["data-type"];
        this.vehicleTypeId = newTab.$attrs["data-type-id"];
        this.getAll({
          vehicleType: newTab.$attrs["data-type"],
          limit: 10000,
          page: 1,
        });
      }
    },
    prepareKeysForModal(payloadData) {
      this.updatedValues = {};
      this.dataForModal = {};
      if (!payloadData) {
        for (const key in this.vehicleTypeAndCharacteristics[0]) {
          this.dataForModal[key] = null;
        }
      } else {
        if (this.editData) {
          this.bodyTypesCarsSelectedOption =
            this.bodyTypesCarsSelectOptions.find(
              (bodyTypes) =>
                bodyTypes.label == this.editData.car_examples__body_type
            );
          this.vehicleClassCarsSelectedOption =
            this.vehicleClassCarsSelectOptions.find((vehicleClass) => {
              return (
                vehicleClass.label == this.editData.car_examples__vehicle_class
              );
            });
          this.vehicleMarksSelectedOption = this.vehicleMarksSelectOptions.find(
            (mark) =>
              mark.vehicle_marks__id == this.editData.vehicle_examples__mark_id
          );
        }
        this.dataForModal = Object.assign({}, payloadData);
      }
    },
  },

  mounted() {
    EventBus.$on("selectTableRows", (payload) => {
      this.activeSelectRow = payload.data.vehicle_examples__id;
    });
    EventBus.$on("openModal", (payload) => {
      this.$modal.show("addModelModal", {
        callback: this.clickLoadData,
        data: payload.data,
        id: payload.data.vehicle_examples__id,
      });
    });

    SelectsService.getOneByField("car_examples__body_type").then(
      (bodyTypesCarsSelectOptionsData) => {
        this.bodyTypesCarsSelectOptions =
          bodyTypesCarsSelectOptionsData.data.data.rows;
        if (this.editData) {
          this.bodyTypesCarsSelectedOption =
            bodyTypesCarsSelectOptionsData.data.data.rows.find(
              (bodyTypes) =>
                bodyTypes.label == this.editData.car_examples__body_type
            );
        }
      }
    );

    SelectsService.getOneByField("car_examples__vehicle_class").then(
      (vehicleClassCarsSelectOptionsData) => {
        this.vehicleClassCarsSelectOptions =
          vehicleClassCarsSelectOptionsData.data.data.rows;
        if (this.editData) {
          this.vehicleClassCarsSelectedOption =
            vehicleClassCarsSelectOptionsData.data.data.rows.find(
              (vehicleClass) => {
                console.log(
                  vehicleClass.label,
                  this.editData,
                  this.editData.car_examples__vehicle_class
                );
                return (
                  vehicleClass.label ==
                  this.editData.car_examples__vehicle_class
                );
              }
            );
        }
      }
    );

    VehicleMarksService.getAll().then((vehicleMarksSelectOptionsData) => {
      this.vehicleMarksSelectOptions = vehicleMarksSelectOptionsData.data.data;

      if (this.editData) {
        this.vehicleMarksSelectedOption =
          vehicleMarksSelectOptionsData.data.data.find(
            (mark) =>
              mark.marks__id == this.editData.car_examples__vehicle_class
          );
      }
    });
  },
  created() {
    this.getAll({ vehicleType: this.activeTab, page: 1, limit: 10000 });
    this.getAllMarks({ limit: 10000 });

    SelectsService.getAll()
      .then((data) => {})
      .catch((error) => {});
  },
  watch: {
    loadStatus(newValue, oldValue) {
      if (newValue === "success") {
        this.vehicleTypeAndCharacteristicsFiltered =
          this.vehicleTypeAndCharacteristics;
      }
    },
  },
  computed: {
    ...mapState("vehicleTypeAndCharacteristicsModule", [
      "vehicleTypeAndCharacteristics",
      "loadStatus",
    ]),
    ...mapState("vehicleMarksModule", ["vehicleMarks"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapGetters("vehicleTypeAndCharacteristicsModule", ["numPages"]),

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: 30,
          align: "center",
        },
        {
          field: "vehicle_marks__logo",
          key: "163226",
          title:
            this.dataLang["vehicle_marks_table_header__vehicle_marks__logo"],
          align: "center",
          width: "33%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <img
                style={"cursor: pointer"}
                width={100}
                height={100}
                src={row.vehicle_marks__logo}
              />
            );
          },
        },
        {
          field: "vehicle_marks__name",
          key: "16326",
          title:
            this.dataLang["vehicle_marks__table_header__vehicle_marks__name"],
          align: "center",
          width: "33%",
          sortBy: "asc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_marks__id",
          key: "163236",
          title:
            this.dataLang["vehicle_marks__table_header__vehicle_marks__id"],
          align: "center",
          sortBy: "asc",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },
    columnsMainTable() {
      return [
        {
          field: "",
          key: "a",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "vehicle_examples__company_id",
          key: "vehicle_examples__company_id",
          title: "ID родителя",
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"vehicle_examples__company_id"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__id",
          key: "car_examples__id",
          title:
            this.dataLang[
              "vehicle_examples__table_header__vehicle_examples__id"
            ],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__id"}
                />
              </div>
            );
          },
        },
        {
          field: "vehicle_marks__name",
          key: "vehicle_marks__name",
          title: this.dataLang["vehicle_marks__name"],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"vehicle_marks__name"}
                />
              </div>
            );
          },
        },
        {
          field: "vehicle_examples__model",
          key: "vehicle_examples__model",
          title: this.dataLang["vehicle_examples__name"],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"vehicle_examples__model"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__body_generation",
          key: "car_examples__body_generation",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__body_generation"
            ],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__body_generation"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__body_type",
          key: "car_examples__body_type",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__body_type"
            ],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__body_type"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__count_doors",
          key: "car_examples__count_doors",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__count_doors"
            ],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__count_doors"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__count_places",
          key: "car_examples__count_places",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__count_places"
            ],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__count_places"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__trunk_volume",
          key: "car_examples__trunk_volume",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__trunk_volume"
            ],
          sortBy: "",
          width: 210,
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__trunk_volume"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__ground_clearance",
          key: "car_examples__ground_clearance",
          title:
            this.dataLang[
              "vehicle_examples__table_header__car_examples__ground_clearance"
            ],
          sortBy: "",
          width: 190,
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__ground_clearance"}
                />
              </div>
            );
          },
        },
        {
          field: "car_examples__tank_capacity",
          key: "car_examples__tank_capacity",
          title: this.dataLang["car_examples__tank_capacity"],
          sortBy: "",
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class={"tw-pointer-events-none"}>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  class={"tw-pointer-events-auto"}
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  onInput={this.fillFilter}
                  inputName={"car_examples__tank_capacity"}
                />
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
